export const TOGGLE_MODAL_ROOM_BOX = "TOGGLE_MODAL_ROOM_BOX";

export const toggleModalRoomBox = (status) => ({
  type: TOGGLE_MODAL_ROOM_BOX,
  payload: status,
});
